export const environment = {
    production: true,
    serverUrl: 'https://igrade.ucr.edu',
    enableGoogleAnalytics: true,
    envName: 'Prod'
};
